<template>
    <div class="form component-section">
        <div class="d-flex align-items-center justify-content-between mb-3">
            <h4 class="mb-0">Burofaxes enviados</h4>

            <button class="btn btn-download icon-wrapper"
                    @click="this.modalToShow = 'upload-files'"
            >
                <i class="uq-icon d-inline-block bi-card-text pe-2"
                   :class="{rotate: updatingBurofax}"/>
                Nuevo Burofax
            </button>
        </div>

        <div v-if="!!expedient?.burofaxes && expedient.burofaxes?.length > 0 && can('burofax.index')">
            <div v-for="burofax in expedient.burofaxes" :key="burofax.id" class="d-flex">
                <div class="d-flex flex-column justify-content-center pb-2 pe-2">
                    <div class="d-flex align-items-center mb-2">
                        <button class="btn btn-download icon-wrapper"
                                v-if="can('burofax.download')"
                                title="Descargar burofax"
                                @click="downloadBurofax(burofax, 'Burofax')">
                            <i class="uq-icon bi-download"/>
                        </button>
                    </div>

                    <div class="d-flex align-items-center mb-2">
                        <button class="btn btn-download icon-wrapper"
                                v-if="burofax.type !== 'Burofax Postal' && can('burofax.download.acuse')"
                                title="Descargar acuse de recibo"
                                @click="downloadBurofax(burofax, 'AcuseRecibo')">
                            <i class="uq-icon bi-receipt"/>
                        </button>
                    </div>

                    <div class="d-flex align-items-center mb-2">
                        <button class="btn btn-download icon-wrapper primary"
                                title="Actualizar información"
                                :disabled="updatingBurofax"
                                @click="updateBurofaxStatus(burofax)">
                            <i class="uq-icon d-inline-block bi-arrow-clockwise"
                               :class="{rotate: updatingBurofax}"/>
                        </button>
                    </div>
                </div>

                <div class="d-flex flex-column justify-content-center mb-2">
                    <div class="d-flex flex-column ms-2">
                        <div class="d-flex align-items-start mb-2">
                            <span class="badge bg-primary fs-6 me-3">Tipo</span>
                            <span>{{ burofax.type }}</span>
                        </div>
                    </div>

                    <div class="d-flex flex-column ms-2">
                        <div class="d-flex align-items-start mb-2">
                            <span class="badge bg-primary fs-6 me-3">Referencia</span>
                            <span>{{ burofax.reference }}</span>
                        </div>

                        <div class="d-flex align-items-start mb-2">
                            <span class="badge bg-primary fs-6 me-3">Status</span>
                            <span>{{ burofax.status }}</span>
                        </div>
                    </div>

                    <div class="d-flex flex-column ms-2">
                        <div class="d-flex align-items-start mb-2">
                            <span class="badge bg-primary fs-6 me-3">Fecha de envio</span> <span>{{
                                formatDateToHuman(burofax.created_at)
                            }}</span>
                        </div>

                        <div class="d-flex align-items-start mb-2">
                            <span class="badge bg-primary fs-6 me-3">Enviado por</span> <span>{{
                                burofax.sendBy.name
                            }}</span>
                        </div>
                    </div>
                </div>

                <hr class="hr hr-blurry"/>
            </div>
        </div>

        <div v-else>
            <span class="content-text">No hay burofaxes relacionados</span>
        </div>

        <v-modal-slot id="upload-files-expedient-modal"
                      v-if="modalToShow === 'upload-files'"
                      @closed="modalToShow = ''"
                      @accepted="newBurofax"
        >

            <template v-slot:modal-title>
                Enviar nuevo burofax
            </template>

            <template v-slot:modal-content>
                <div class="row">
                    <div class="col-12 mb-4">
                        <input type="file" id="burofax_file" @change="setFile" accept="application/pdf">
                    </div>

                    <div class="col-12 d-flex">
                        <burofax-template-preview-page-settings
                            :expedient="expedient"
                            @updatedSettings="updateData"
                        />
                    </div>
                </div>
            </template>

            <template v-slot:accept-button>
                Enviar
            </template>

            <template v-slot:close-button @click="modalToShow = ''">
                Cerrar
            </template>
        </v-modal-slot>
    </div>
</template>

<script>
import { can } from "../../../../helpers/Permissions";
import { createBurofax, getBurofax } from "../../../../helpers/requests/RequestsBurofaxes";
import { formatDateToHuman } from "../../../../helpers/DateHelper";
import ExpedientDetailUploadFilesModal from "./ExpedientDetailUploadFilesModal.vue";
import VModalSlot from "../../../general/VModalSlot.vue";
import FilesExpedient from "../FilesExpedient.vue";
import BurofaxTemplatePreviewPageSettings from "../../../templates/parts/BurofaxTemplatePreviewPageSettings.vue";

export default {
    name: "ExpedientDetailBurofaxes",
    components: {BurofaxTemplatePreviewPageSettings, FilesExpedient, VModalSlot, ExpedientDetailUploadFilesModal},
    props: {
        expedient: {
            type: Object,
            required: true,
        }
    },
    setup() {
        return {
            can,
        }
    },
    data() {
        return {
            updatingBurofax: false,
            modalToShow: '',
            burofaxFile: null,

            data: {
                selected_type: '',
                selected_id: '',
                type: '',
                burofax_type: '',
                selected: '',
                plazo: '',
                plazo_disponibilidad: '',
                es_electronico: '',
                acuse_recibo: '',
                copia_certificada: '',
                copia_testimonial: '',
                copia_testimonial_notario: '',
                email_receiver: '',
            }
        }
    },
    methods: {
        formatDateToHuman,
        async updateBurofaxStatus(burofax) {
            try {
                this.updatingBurofax = true;

                await getBurofax(burofax.id);
            } catch (e) {
                if (!!e?.response?.data?.message) {
                    alert(e.response.data.message);
                } else {
                    alert('Ha ocurrido un error al actualizar el burofax');
                }
            } finally {
                this.updatingBurofax = false;
                this.$emit('updateExpedient');
            }
        },
        async downloadBurofax(burofax, type) {
            try {
                const response = await axios.get(`/api/burofax/${burofax.id}/download/${type}`, {
                    responseType: 'blob',
                });

                const blob = new Blob([response.data], {type: 'application/pdf'});
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;

                const name = (type === 'Burofax' ? 'BU_' : 'AC_') + burofax.reference.toString() + '.pdf';

                link.setAttribute('download', name);
                document.body.appendChild(link);
                link.click();
            } catch (e) {
                if (type === 'AcuseRecibo') {
                    alert('Ha ocurrido un error al descargar el acuse de recibo. Hasta que no esté en estado finalizado no podrá descargárselo.')
                } else {
                    alert(`Error al descargar el burofax`);
                }
            }
        },
        async newBurofax() {
            try {
                this.data.burofax_file = this.burofaxFile;

                await createBurofax(this.expedient.id, 0, this.data);

                alert('Burofax enviado con éxito.');

                this.$emit('burofax_sent');
            } catch (e) {
                if (!!e?.response?.data?.message) {
                    alert(e.response.data.message);
                } else {
                    alert('Ha ocurrido un error al enviar el burofax');
                }
            } finally {
                this.modalToShow = '';
            }
        },
        updateData(data) {
            this.data = data;
        },
        async setFile(event) {
            const makeReader = new Promise((resolve) => {
                let reader = new FileReader();

                reader.readAsDataURL(event.target.files[0]);

                reader.onload = () => {
                    console.log(reader)
                    resolve(reader.result);
                };
            });

            try {
                this.burofaxFile = await makeReader;
            } catch (e) {
                this.modalToShow = '';

                alert('Ha ocurrido un error al cargar el archivo');
            }
        }
    },
}
</script>
